import type { ImageGalleryImage } from '../crop-circle/Components/ImageGallery';
import type { RoutineExecutionProps } from '../routine/components/routineButtons';
import { createContext, useContext } from 'react';

// rather than passing callbacks all the way down, IssueContext can be used to provide the callbacks to the components that need them

export interface IssueContextData {
  onRoutineSelected: (props: RoutineExecutionProps) => Promise<void>;
  onRouteToIssue: (issueId: string) => Promise<void>;
  /**
   * Opens a routine answer's images in a side panel. Only the surfaces that own
   * a column stack supply it; where it is undefined the thumbnails keep their
   * modal lightbox, which is what native and the single-column web shell use.
   */
  onViewImages?: (images: ImageGalleryImage[], initialIndex: number) => void;
}

export const IssueContext = createContext<IssueContextData | undefined>(
  undefined
);

export const useIssueContext = (): IssueContextData | undefined => {
  return useContext(IssueContext)!;
};
